/**
 * An error whose message was written for the person using the app, and is safe
 * to show verbatim.
 *
 * Everything else — a TypeError from fetch, a stack from a library, a server's
 * internal message — is translated by `describeError` instead of shown as-is.
 * Kept in its own file with no imports so anything, including the session and
 * audio layers, can extend it without an import cycle.
 */
export class UserFacingError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'UserFacingError';
  }
}
